/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ComposeIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "compose", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M14 5.5H5.5V19.5H19.5V11", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 13.5L9 16L11.5 15.5L21 6L19 4L9.5 13.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17 6L19 8", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ComposeIcon);
export default ForwardRef;
//# sourceMappingURL=composeIcon.js.map